function base64UrlDecode(str) {
  const base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function decodeJwtPayload(token) {
  try {
    const payload = token.split(".")[1];
    const json = base64UrlDecode(payload);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isJwtExpired(token, bufferSeconds = 60) {
  const data = decodeJwtPayload(token);
  if (!data || typeof data.exp !== "number") return false;
  const now = Date.now() / 1000;
  return now >= data.exp - bufferSeconds;
}
